
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/policy",
      function () {
        return require("private-next-pages/about/policy/index.page_en_US.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/policy"])
      });
    }
  